import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

const THEMES = {
  light: {
    id: 'light',
    label: 'Claro',
    vars: {
      '--app-bg': '#FAF7F4',
      '--card-bg': '#FFFFFF',
      '--elevated-bg': '#F0ECE8',
      '--text-primary': '#1A1210',
      '--text-secondary': '#6B5E54',
      '--text-muted': '#9E9590',
      '--glass-rgb': '255, 255, 255',
      '--gradient-warm-start': '#EB2A34',
      '--gradient-warm-mid': '#D42020',
      '--gradient-warm-end': '#D4A800',
      '--gradient-cool-start': '#D4A800',
      '--gradient-cool-mid': '#C09500',
      '--gradient-cool-end': '#EB2A34',
      '--gradient-nature-start': '#A62A30',
      '--gradient-nature-mid': '#EB2A34',
      '--gradient-nature-end': '#D4A800',
      '--papo-red': '#D42020',
      '--papo-gold': '#C09500',
      '--papo-deep-red': '#A62A30',
      '--background': '25 30% 97%',
      '--foreground': '15 25% 8%',
      '--card': '0 0% 100%',
      '--card-foreground': '15 25% 8%',
      '--popover': '0 0% 100%',
      '--popover-foreground': '15 25% 8%',
      '--primary': '0 78% 48%',
      '--primary-foreground': '0 0% 100%',
      '--secondary': '25 20% 93%',
      '--secondary-foreground': '15 25% 8%',
      '--muted': '25 15% 92%',
      '--muted-foreground': '15 8% 45%',
      '--accent': '25 15% 92%',
      '--accent-foreground': '15 25% 8%',
      '--destructive': '0 55% 50%',
      '--destructive-foreground': '0 0% 100%',
      '--border': '25 15% 88%',
      '--input': '25 15% 88%',
      '--ring': '0 78% 48%',
    }
  },
  dark: {
    id: 'dark',
    label: 'Escuro',
    vars: {
      '--app-bg': '#0A0A0A',
      '--card-bg': '#161412',
      '--elevated-bg': '#1E1C1A',
      '--text-primary': '#F0EBE3',
      '--text-secondary': '#9E9590',
      '--text-muted': '#6B6360',
      '--glass-rgb': '14, 12, 10',
      '--gradient-warm-start': '#EB2A34',
      '--gradient-warm-mid': '#D42020',
      '--gradient-warm-end': '#FFD700',
      '--gradient-cool-start': '#FFD700',
      '--gradient-cool-mid': '#F0A500',
      '--gradient-cool-end': '#EB2A34',
      '--gradient-nature-start': '#A62A30',
      '--gradient-nature-mid': '#EB2A34',
      '--gradient-nature-end': '#FFD700',
      '--papo-red': '#EB2A34',
      '--papo-gold': '#FFD700',
      '--papo-deep-red': '#A62A30',
      '--background': '15 15% 4%',
      '--foreground': '25 20% 92%',
      '--card': '15 12% 8%',
      '--card-foreground': '25 20% 92%',
      '--popover': '15 12% 8%',
      '--popover-foreground': '25 20% 92%',
      '--primary': '0 78% 54%',
      '--primary-foreground': '0 0% 100%',
      '--secondary': '15 8% 14%',
      '--secondary-foreground': '25 20% 92%',
      '--muted': '15 8% 14%',
      '--muted-foreground': '15 8% 55%',
      '--accent': '15 8% 14%',
      '--accent-foreground': '25 20% 92%',
      '--destructive': '0 55% 50%',
      '--destructive-foreground': '0 0% 100%',
      '--border': '15 8% 18%',
      '--input': '15 8% 18%',
      '--ring': '0 78% 54%',
    }
  },
  midnight: {
    id: 'midnight',
    label: 'Meia-Noite',
    vars: {
      '--app-bg': '#050508',
      '--card-bg': '#0E0E14',
      '--elevated-bg': '#16161E',
      '--text-primary': '#E8E4F0',
      '--text-secondary': '#8E8A96',
      '--text-muted': '#5E5A66',
      '--glass-rgb': '10, 10, 16',
      '--gradient-warm-start': '#EB2A34',
      '--gradient-warm-mid': '#D42020',
      '--gradient-warm-end': '#FFD700',
      '--gradient-cool-start': '#FFD700',
      '--gradient-cool-mid': '#F0A500',
      '--gradient-cool-end': '#EB2A34',
      '--gradient-nature-start': '#A62A30',
      '--gradient-nature-mid': '#EB2A34',
      '--gradient-nature-end': '#FFD700',
      '--papo-red': '#EB2A34',
      '--papo-gold': '#FFD700',
      '--papo-deep-red': '#A62A30',
      '--background': '240 20% 3%',
      '--foreground': '260 15% 92%',
      '--card': '240 18% 7%',
      '--card-foreground': '260 15% 92%',
      '--popover': '240 18% 7%',
      '--popover-foreground': '260 15% 92%',
      '--primary': '0 78% 54%',
      '--primary-foreground': '0 0% 100%',
      '--secondary': '240 10% 12%',
      '--secondary-foreground': '260 15% 92%',
      '--muted': '240 10% 12%',
      '--muted-foreground': '260 8% 50%',
      '--accent': '240 10% 12%',
      '--accent-foreground': '260 15% 92%',
      '--destructive': '0 55% 50%',
      '--destructive-foreground': '0 0% 100%',
      '--border': '240 10% 16%',
      '--input': '240 10% 16%',
      '--ring': '0 78% 54%',
    }
  },
  resistance: {
    id: 'resistance',
    label: 'Resistencia',
    vars: {
      '--app-bg': '#0D0806',
      '--card-bg': '#1A1210',
      '--elevated-bg': '#241A16',
      '--text-primary': '#F0E6DC',
      '--text-secondary': '#A09080',
      '--text-muted': '#6B5E54',
      '--glass-rgb': '18, 14, 10',
      '--gradient-warm-start': '#EB2A34',
      '--gradient-warm-mid': '#D42020',
      '--gradient-warm-end': '#FFD700',
      '--gradient-cool-start': '#FFD700',
      '--gradient-cool-mid': '#F0A500',
      '--gradient-cool-end': '#EB2A34',
      '--gradient-nature-start': '#A62A30',
      '--gradient-nature-mid': '#EB2A34',
      '--gradient-nature-end': '#FFD700',
      '--papo-red': '#EB2A34',
      '--papo-gold': '#FFD700',
      '--papo-deep-red': '#A62A30',
      '--background': '15 25% 4%',
      '--foreground': '25 30% 92%',
      '--card': '15 20% 8%',
      '--card-foreground': '25 30% 92%',
      '--popover': '15 20% 8%',
      '--popover-foreground': '25 30% 92%',
      '--primary': '0 78% 54%',
      '--primary-foreground': '0 0% 100%',
      '--secondary': '15 15% 12%',
      '--secondary-foreground': '25 30% 92%',
      '--muted': '15 15% 12%',
      '--muted-foreground': '15 12% 48%',
      '--accent': '15 15% 12%',
      '--accent-foreground': '25 30% 92%',
      '--destructive': '0 55% 50%',
      '--destructive-foreground': '0 0% 100%',
      '--border': '15 15% 16%',
      '--input': '15 15% 16%',
      '--ring': '0 78% 54%',
    }
  }
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('papo-theme') || 'dark';
  });

  useEffect(() => {
    const t = THEMES[theme];
    if (!t) return;
    const root = document.documentElement;
    Object.entries(t.vars).forEach(([key, val]) => {
      root.style.setProperty(key, val);
    });
    localStorage.setItem('papo-theme', theme);
    document.body.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
